import Dialog, { createDialogButton, createDialogCloseButton } from "~/ui/dialogs/dialog";
import { node } from "~/util/dom";

export function confirm(cancelLabel: string, confirmLabel: string, body: string | HTMLElement): Promise<boolean> {
	return new Promise(resolve => {
		const dialog = new Dialog({
			closeOnBackdropClick: false,
		});
		const cancelButton = createDialogButton({ type: "button" }, cancelLabel);
		const confirmButton = createDialogButton({ type: "button", className: "ui-confirm__confirmButton" }, confirmLabel);
		const closeButton = createDialogCloseButton();
		const buttons = node("div", { className: "ui-confirm__buttons" });

		closeButton.addEventListener("click", () => {
			resolve(false);
			dialog.close();
		});
		cancelButton.addEventListener("click", () => {
			resolve(false);
			dialog.close();
		});
		confirmButton.addEventListener("click", () => {
			resolve(true);
			dialog.close();
		});
		dialog.container.classList.add("ui-confirm");
		dialog.container.append(closeButton, typeof body === "string" ? node("p", { className: "ui-confirm__body" }, body) : body, buttons);
		buttons.append(confirmButton, cancelButton);
		dialog.open();
	});
}
